import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";

const Table19 = ({ koosheshFekriScore, setKoosheshFekriScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.koosheshFekri;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 12, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 24, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 36, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 48, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 60, isSelected: masouliat.value == 4 },

      ]


      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setKoosheshFekriScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "koosheshFekri": selectedItem }))
    }
  }, [reload])



  return (
    <div>
      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          شغل مستلزم کاربرد
          مهارتها و روش های
          ساده و تکراری بوده و
          نیاز کمی به دقت و
          تمرکز حواس داشته و با
          ابزارهای ساده سر و کار
          دارد.
        </Column>
        <Column paddingY={30}>
          شغل مستلزم کاربرد
          مهارتها و روش های
          متعدد و یا پیچیده بوده و
          نیاز به دقت و تمرکز
          حواس زیاد داشته و با
          ابزارهای دقیقی سر و کار
          دارد.
        </Column>
        <Column paddingY={30}>
          شغل مستلزم تجزیه و
          تحلیل مسائل مختلف
          بوده و نیاز به
          مهارتهای نسبتا
          پیچیده در تحلیل
          مسائل دارد.
        </Column>
        <Column paddingY={30}>
          شغل مستلزم تدوین
          روش های مختلف
          بوده، با مسائل پیچیده
          سر و کار داردو نیاز
          به ابتکار و خالقیت
          باال دارد.
        </Column>
        <Column paddingY={30}>
          شغل مستلزم حل مسائل
          پیچیده مدیریتی و
          عملیاتی بوده و نیاز به
          مهارتهای فکری باال در
          تدوین راهبردهای سازمان
          دارد.
        </Column>
      </Row>
      <Row>

        <Column isActive={koosheshFekriScore == 12}>12</Column>
        <Column isActive={koosheshFekriScore == 24}>24</Column>
        <Column isActive={koosheshFekriScore == 36}>63 </Column>
        <Column isActive={koosheshFekriScore == 48}> 48</Column>
        <Column isActive={koosheshFekriScore == 60}> 60</Column>

      </Row>
    </div>
  );
};

export default Table19;
